import React from 'react';
import { CommandBarButton, IconButton } from '@fluentui/react';
import DetailsTable from '../../../../Table/DetailsTable';

const CoBrandTableAdvisors = ({
    cobrands,
    setSelectedCoBrand,
    loading,
    editOnClick,
    createOnClick,
    previewOnClick,
}) => {
    const columns = [
        {
            minWidth: 30,
            maxWidth: 30,
            onRender: (item) => (
                <ContextualMenu editOnClick={editOnClick} previewOnClick={previewOnClick} id={item.coBrandId} />
            ),
        },
        {
            name: 'CoBrandID',
            fieldName: 'coBrandId',
            minWidth: 120,
            maxWidth: 120,
            isResizable: true,
            isSorted: true,
            isSortedDescending: true,
        },
        {
            name: 'CoBrand',
            fieldName: 'name',
            minWidth: 120,
            maxWidth: 120,
            isResizable: true,
            isSorted: true,
            isSortedDescending: true,
        },
        {
            name: 'Title',
            fieldName: 'title',
            minWidth: 140,
            maxWidth: 140,
            isResizable: true,
            isSorted: true,
            isSortedDescending: true,
        },
        {
            name: 'International On/Off',
            fieldName: 'internationalOn',
            minWidth: 200,
            maxWidth: 200,
            isResizable: true,
            isSorted: true,
            isSortedDescending: true,
        },
        {
            name: 'On/Off Default',
            fieldName: 'onOffDefault',
            minWidth: 300,
            maxWidth: 350,
            isResizable: true,
        },
    ];

    const items = cobrands ?? [];

    const selectionHook = (items) => {
        setSelectedCoBrand(items && items[0] && items[0].Name);
    };

    return (
        <DetailsTable
            items={items}
            columns={columns}
            selectionHook={selectionHook}
            loading={loading}
            mainColumn={'title'}
            style={{
                position: 'relative',
                height: '80vh',
                width: '80vw',
            }}
            CommandBar={
                <>
                    <CommandBarButton
                        iconProps={{ iconName: 'Edit' }}
                        text="Bulk Edit/Create"
                        onClick={() => createOnClick()}
                    />
                </>
            }
        />
    );
};

const moreIcon = { iconName: 'More' };

const ContextualMenu = ({ editOnClick, deleteOnClick, id, ...rest }) => {
    const menuProps = {
        items: [
            {
                key: 'print',
                iconProps: { iconName: 'Edit' },
                text: 'Edit',
                onClick: () => editOnClick(id),
            },
        ],
    };

    return <IconButton iconProps={moreIcon} menuProps={menuProps} onRenderMenuIcon={() => {}} {...rest} />;
};

export default CoBrandTableAdvisors;
